const messages = {
	en: {
		translations: {
			signup: {
				title: "Create account",
				step1Title: "Enter your CNPJ and email to get started.",
				step2Title: "Enter the code sent to your email.",
				step3Title: "Complete your company details and password.",
				toasts: {
					success: "User created successfully! Please login!",
					fail: "Error creating user. Check the reported data.",
					codeSent: "Code sent to your email.",
					emailValidated: "Email verified. Fill in the details below.",
				},
				form: {
					companyName: "Company name",
					companyNamePlaceholder: "Your company name",
					cnpj: "CNPJ",
					cnpjPlaceholder: "00.000.000/0000-00",
					cnpjIncomplete: "CNPJ must have 14 digits.",
					cnpjInvalid: "Invalid CNPJ. Check the digits.",
					name: "Full name",
					namePlaceholder: "Maria Silva",
					email: "Email",
					emailPlaceholder: "you@example.com",
					emailInvalid: "Invalid email.",
					password: "Password",
					passwordPlaceholder: "At least 8 characters",
					passwordHint: "Min. 8 characters, 1 uppercase and 1 special.",
					passwordWeak: "Weak password: use 8+ characters, 1 uppercase and 1 special.",
					passwordStrengthWeak: "Weak",
					passwordStrengthMedium: "Medium",
					passwordStrengthStrong: "Strong",
					phone: "Phone",
					countryCode: "Country",
					phonePlaceholder: "(00) 00000-0000",
					code: "Verification code",
					codePlaceholder: "000000",
				},
				buttons: {
					sendCode: "Send code",
					sendingCode: "Sending…",
					validateEmail: "Verify email",
					validatingEmail: "Verifying…",
					submit: "Create account",
					creating: "Creating account…",
					login: "Already have an account? Log in!",
					loginPrefix: "Already have an account?",
					loginLink: "Sign in",
				},
				errors: {
					codeInvalidOrExpired: "Invalid or expired code.",
					rateLimit: "Too many attempts. Try again in 15 minutes.",
				},
			},
			login: {
				title: "Welcome back",
				subtitle: "Sign in with your account to continue.",
				form: {
					email: "Email",
					emailPlaceholder: "you@example.com",
					password: "Password",
					passwordPlaceholder: "••••••••",
				},
				buttons: {
					submit: "Sign in",
					register: "Don't have an account? Sign up",
					registerPrefix: "Don't have an account?",
					registerLink: "Sign up",
					recover: "Forgot your password?",
					showPassword: "Show",
					hidePassword: "Hide",
				},
				toggle: {
					login: "Sign in",
					signup: "Sign up",
				},
				hero: {
					tagline: "All your channels in one place.",
					productSubtitle: "Multi Channel Inbox",
				},
			},
			recoverPassword: {
				title: "Forgot your password?",
				subTitle:
					"No problems! Just enter your email and we'll send you login instructions.",
				form: {
					email: "Email",
					emailPlaceholder: "Enter your email",
					emailInvalid: "Please enter a valid email.",
				},
				buttons: {
					submit: "Recover Password",
					return: "Go back",
				},
				toasts: {
					emailSent: "If the email is registered, you will receive a link shortly.",
					checkInbox: "Check your inbox (and spam) and click the link to set a new password.",
				},
			},
			resetPassword: {
				title: "New password",
				subTitle: "Set a new password for your account.",
				form: {
					password: "New password",
					passwordPlaceholder: "Enter new password",
					confirmPassword: "Confirm password",
					confirmPasswordPlaceholder: "Repeat new password",
					passwordMismatch: "Passwords do not match.",
				},
				buttons: {
					submit: "Save password",
					returnLogin: "Go to login",
					requestNew: "Request a new link",
				},
				toasts: {
					success: "Password updated successfully! Please log in.",
				},
				errors: {
					invalidLink: "Invalid or expired link. Request password recovery again.",
				},
			},
			auth: {
				toasts: {
					success: "Login successfully!",
				},
			},
			errorFallback: {
				error: "Something went wrong",
				instructions: "Please refresh the page or try again in a moment. If the problem continues, contact support.",
				detail: "Technical detail",
			},
			dashboard: {
				epoch: {
					buttons: {
						today: "Today",
						week: "Week",
						month: "Month",
						year: "Year",
					},
				},
				charts: {
					perDay: {
						title: "Tickets today: ",
					},
					attendantsChart: {
						title: "Active calls by attendants",
						sideTitle: "Calls",
					},
					progressBar: {
						callsByDepartment: "Calls by department",
						callsByAttendant: "Attendant Calls",
						ratingsByAttendant: "Ratings by Attendant",
					},
				},
				departments: {
					title: "Departments",
				},
				messages: {
					inAttendance: {
						title: "In Service",
					},
					waiting: {
						title: "Waiting",
					},
					closed: {
						title: "Closed",
					},
					connection: {
						title: "Connections",
					},
					waitingTime: {
						title: "Average waiting time",
					},
					serviceTime: {
						title: "Average service time",
					},
					averageRating: {
						title: "Average rating",
					},
					contacts: {
						title: "Contacts",
					},
					messages: {
						title: "Messages",
					},
					reviews: {
						title: "Reviews",
					},
				},
				infoCard: {
					ticketsToday: "Number of Tickets being handled.",
					awaitingService: "Number of Tickets awaiting service.",
					ticketsSolved: "Number of Tickets resolved.",
					connections: "Number of connected channels.",
					waitingTime: "Average time Tickets wait to be served.",
					serviceTime: "Average time in which operators perform the service.",
					averageRating: "Average rating of service evaluation.",
					contactNumber: "Total number of Contacts.",
					messagesNumber: "Total number of messages exchanged.",
					reviews: "Total number of reviews received.",
				},
			},
			connections: {
				title: "Connections",
				subtitle: "Manage channels, sessions and platform integrations.",
				listTitle: "Connections list",
				searchPlaceholder: "Search connection...",
				empty: "No connections found.",
				emptyHint: "Try a different search term.",
				toasts: {
					deleted: "WhatsApp connection deleted sucessfully!",
					webhookUpdated: "Webhook reconnected successfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? It cannot be reverted.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to read QR Code again.",
				},
				buttons: {
					add: "Add connection",
					edit: "Edit",
					delete: "Delete",
					disconnect: "Disconnect",
					tryAgain: "Try Again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connectiing",
					restart: "Restart Backend",
					reconnectWebhook: "Reconnect webhook",
				},
				toolTips: {
					disconnected: {
						title: "Failed to start WhatsApp session",
						content:
							"Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code read",
						content:
							"Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
					},
					connected: {
						title: "Connection established",
					},
					timeout: {
						title: "Connection with cell phone has been lost",
						content:
							"Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
					},
				},
				table: {
					id: "Instance ID",
					name: "Name",
					status: "Status",
					lastUpdate: "Last Update",
					default: "Default",
					actions: "Actions",
					session: "Session",
					channel: "Channel",
				},
				marketplace: {
					configured: "Already configured",
					configuredTitle: "List of added channels",
					configuredDescription: "Manage your active connections.",
					channelPrefix: "Channel",
					sessionStatus: {
						connected: "Connected",
						connecting: "Connecting",
						qrcode: "Waiting for QR Code",
						disconnected: "Disconnected",
						timeout: "Session expired",
						pairing: "Pairing",
					},
					createdAt: "Created on",
					hubBadge: "Hub",
					integrationTypes: {
						native: "Native",
						hub: "Hub",
						seamless: "Seamless",
					},
					channelTypes: {
						instagram: "Instagram V2",
						webchat: "WebChat",
						sms: "SMS",
						mercadolivre: "Mercado Livre",
						tiktok: "TikTok",
						ifood: "iFood",
						youtube: "YouTube",
						numero_virtual: "Virtual Number",
						olx: "OLX",
						linkedin: "LinkedIn",
						magalu: "Magalu",
						gbm: "Google My Business",
						google_ads: "Google Ads",
						meta_ads: "Meta Ads",
						shein: "Shein",
						shopee: "Shopee",
					},
				},
				wizard: {
					subtitle: "Follow the steps to set up the new connection.",
					stepOf: "Step {{current}} of {{total}}",
					channelSelected: "Selected channel",
					back: "Back",
					next: "Next",
					errors: {
						nameRequired: "Enter the connection name.",
					},
					stepDescriptions: {
						basic: "Choose a name and whether this is the default connection.",
						messages: "Optional greeting and farewell messages.",
						queues: "Set queues and chatbot behavior.",
						whatsappcloud: "Enter your WhatsApp Business API credentials.",
						facebook: "Enter the page ID and access token.",
						telegram: "Enter your Telegram bot token.",
						email: "Configure email credentials and servers.",
					},
					steps: {
						basic: "Basic information",
						credentials: "Credentials",
						messages: "Messages",
						queues: "Queues and automation",
						hubChannel: "Hub channel",
						hubDetails: "Connection details",
					},
				},
				hubLinkModal: {
					title: "Link Hub channel",
					subtitle:
						"Choose the channel authorized in your NotificaMe Hub account to activate as a connection.",
					channelLabel: "Hub authorized channel",
					channelPlaceholder: "Select channel",
					channelHint: "Each item shows the channel type (WhatsApp, Instagram, Facebook…) and the name configured in Hub.",
					channelTypeLabel: "Channel type",
					selected: "Selected",
					submit: "Link connection",
					emptyTitle: "No authorized channels found",
					emptyDescription:
						"Configure the channel in the NotificaMe Hub panel and try again.",
					errors: {
						channelRequired: "Select a Hub channel.",
						nameRequired: "Enter the connection name.",
					},
				},
				picker: {
					title: "Add connection",
					subtitle: "Choose an available channel or connect via Seamless.",
					close: "Close",
					recommended: "Recommended",
					selectChannel: "Configure connection",
					addChannel: "Add",
					hubConnect: "Add",
					hubConnectSuccess: "Channel connected successfully!",
					hubConnectError: "Failed to connect channel.",
					hubPopupBlocked: "Popup blocked. Allow popups for this site.",
					hubMissingCompany: "Hub token not configured. Set it in Settings.",
					hubTokenWarning: {
						title: "Hub token not configured",
						description:
							"To link channels via Hub, provide your NotificaMe account token (Account field).",
						path: "Path: Settings → Integrations → Hub Token",
						link: "Configure Hub token",
					},
					seamlessTokenWarning: {
						title: "Seamless integration not configured",
						description:
							"To add channels via Seamless, provide your NotificaMe account token.",
						path: "Path: Settings → Integrations → Hub Token",
						link: "Configure token",
					},
					hubWhatsappNotEnabled: {
						help:
							"Enable the WhatsApp channel on your NotificaMe account (Seamless) and try again. Use the account token (Account field), not a channel-specific token.",
					},
					sections: {
						native: {
							title: "Available channels",
							description:
								"Native WhatsApp (QR) or link channels already configured in your NotificaMe Hub account.",
						},
						hub: {
							title: "Hub channels",
							description:
								"Link channels already configured in your NotificaMe Hub account (WhatsApp, Facebook, Instagram, email, and more).",
						},
						seamless: {
							title: "Seamless channels",
							description:
								"Connect Facebook, Instagram, WhatsApp, YouTube, Google Business, LinkedIn, OLX, Mercado Livre, and TikTok through NotificaMe Seamless. Click Add to authorize with the platform.",
						},
					},
					channels: {
						whatsapp: {
							description: "Connect via QR Code with a local session.",
						},
						whatsappcloud: {
							description: "Use the official WhatsApp Business API (Meta).",
						},
						email: {
							label: "Email",
							description: "Configure sending and receiving via SMTP/IMAP.",
						},
						telegram: {
							description: "Connect a Telegram bot with a token.",
						},
						facebookNative: {
							description: "Manual connection with page credentials.",
						},
						instagramNative: {
							description: "Manual connection with profile credentials.",
						},
						hubIntegration: {
							label: "NotificaMe Hub",
							description:
								"Select a channel already authorized in your Hub account to activate on the platform.",
						},
						hubFacebook: {
							description: "Facebook page connected via Seamless OAuth.",
						},
						hubInstagram: {
							description: "Instagram Direct connected via Seamless OAuth.",
						},
						hubWhatsapp: {
							description: "WhatsApp Business (Meta API) connected via Seamless OAuth.",
						},
						hubYoutube: {
							description: "YouTube channel comments connected via Seamless OAuth.",
						},
						hubGoogleBusiness: {
							description: "Google Business Profile connected via Seamless OAuth.",
						},
						hubLinkedin: {
							description: "LinkedIn page connected via Seamless OAuth.",
						},
						hubOlx: {
							description: "OLX listings chat connected via Seamless OAuth.",
						},
						hubMercadoLivre: {
							description: "Mercado Livre questions and messages connected via Seamless OAuth.",
						},
						hubTiktok: {
							description: "TikTok account connected via Seamless OAuth.",
						},
					},
				},
			},
			integrations: {
				title: "Integrations",
				subtitle: "Connect external services and automate platform workflows.",
				status: {
					connected: "Connected",
					disconnected: "Not configured",
					comingSoon: "Coming soon",
				},
				actions: {
					configure: "Configure",
					documentation: "Documentation",
					menuAria: "Actions for {{name}} integration",
				},
				metrics: {
					status: "Status",
					category: "Category",
					lastSync: "Last sync",
				},
				modal: {
					title: "Configure {{name}}",
					cancel: "Cancel",
					save: "Save",
					connectGoogle: "Connect Google",
					comingSoonToast: "Configuration coming soon.",
					saveSuccess: "Integration configured successfully.",
					saveError: "Could not save configuration.",
				},
				loadError: "Could not load integrations.",
				asaas: {
					name: "Asaas",
					description: "Payments, billing and Pix integrated with support.",
					category: "Payments",
					modalHint:
						"Enter your Asaas API Key to enable automated billing.",
					apiKeyLabel: "API Key",
					apiKeyPlaceholder: "Your Asaas API key",
				},
				googleCalendar: {
					name: "Google Calendar",
					description: "Sync appointments and schedules with Google Calendar.",
					category: "Productivity",
					modalHint:
						"Connect your Google account to sync events with the platform.",
					connectHint: "Click Connect Google to authorize calendar access.",
					connectedHint: "Google account linked to this company. You can disconnect anytime.",
					connectSuccess: "Google Calendar connected successfully.",
					connectError: "Could not connect Google Calendar.",
					disconnect: "Disconnect",
					disconnecting: "Disconnecting…",
					connecting: "Opening Google…",
					disconnectSuccess: "Google Calendar disconnected.",
					disconnectError: "Could not disconnect Google Calendar.",
				},
			},
			googleAgenda: {
				title: "Google Calendar",
				subtitle: "View and manage events from the connected Google account.",
				connectedAs: "Connected as {{email}}",
				goToIntegrations: "Go to Integrations",
				notConnectedTitle: "Google Calendar not connected",
				notConnectedHint:
					"Connect your Google account in Integrations to view and manage the calendar.",
				prevMonth: "Previous month",
				nextMonth: "Next month",
				today: "Today",
				selectedDay: "Day events",
				noEvents: "No events on this day.",
				newEvent: "New event",
				editEvent: "Edit event",
				summary: "Title",
				description: "Description",
				contact: "Contact",
				contactSearch: "Search contact",
				contactSearchHint: "Type at least 3 characters to search.",
				contactHint: "Optional. Links this time slot to a system contact.",
				contactEmpty: "No contacts found.",
				contactClear: "Remove",
				allDay: "All day",
				start: "Start",
				end: "End",
				save: "Save",
				cancel: "Cancel",
				delete: "Delete",
				deleteTitle: "Delete event",
				deleteConfirm: "Are you sure you want to delete this event?",
				loadError: "Could not load events.",
				saveSuccess: "Event saved successfully.",
				saveError: "Could not save the event.",
				deleteSuccess: "Event deleted.",
				deleteError: "Could not delete the event.",
				loading: "Loading…",
				closeDayPanel: "Close",
				eventSingular: "event",
				eventPlural: "events",
				report: "Report",
				settings: "Settings",
				settingsTitle: "Booking settings",
				settingsHint:
					"Set slot duration and how many clients can book the same time (AI and availability).",
				slotMinutes: "Slot duration",
				slotMinutesHint: "E.g. 60 = hourly slots",
				slotCapacity: "Clients per slot",
				slotCapacityHint: "E.g. 2 = two clients at the same time",
				minAdvance: "Minimum advance notice",
				minAdvanceHint:
					"Clients cannot book last-minute — only slots with this lead time.",
				advanceNone: "No restriction",
				advance30m: "30 minutes",
				advance1h: "1 hour",
				advance2h: "2 hours",
				advance3h: "3 hours",
				advance4h: "4 hours",
				advance6h: "6 hours",
				advance12h: "12 hours",
				advance1d: "1 day",
				advance2d: "2 days",
				advance3d: "3 days",
				advance7d: "7 days",
				settingsSave: "Save settings",
				settingsSaveSuccess: "Settings saved.",
				settingsSaveError: "Could not save settings.",
				settingsLoadError: "Could not load settings.",
				minutesSuffix: "min",
				notifyEnabled: "Send a message to the scheduled person",
				notifyHint:
					"Only sends if the booking has a ticket, contact and phone. The same message is used for everyone.",
				notifyWhen: "When to send",
				notifyAtTime: "At the appointment time",
				notify30mBefore: "30 minutes before",
				notify1hBefore: "1 hour before",
				notify2hBefore: "2 hours before",
				notify3hBefore: "3 hours before",
				notify6hBefore: "6 hours before",
				notify12hBefore: "12 hours before",
				notify1dBefore: "1 day before",
				notify30mAfter: "30 minutes after",
				notify1hAfter: "1 hour after",
				notifyConnection: "Sending connection",
				notifyConnectionEmpty: "Select a connection",
				notifyConnectionHint:
					"WhatsApp Business sends a template. Other connections send text.",
				notifyType: "Content",
				notifyTypeText: "Text message",
				notifyTypeTemplate: "Template",
				notifyBody: "Message",
				notifyBodyPlaceholder: "Text sent to every scheduled person",
				notifyBodyRequired: "Enter the text message.",
				notifyTemplateRequired: "Select a template.",
				notifyTemplateConnection: "Connection to list templates",
				notifyTemplateConnectionEmpty: "Select a WABA connection",
				notifyTemplateParam: "Parameter",
				notifyMedia: "Template media",
				notifyMediaUrlPlaceholder: "Media URL (https://...)",
				notifyMediaRequired: "Attach the template image, video or document.",
				notifyTemplateParamsRequired: "Fill in all template parameters, including buttons.",
				notifyAttachMedia: "Attach",
				notifyRemoveMedia: "Remove",
				notifyUploadingMedia: "Uploading...",
			},
			googleAgendaReport: {
				title: "Scheduling report",
				subtitle: "Spreadsheet with all Google Calendar events in the period.",
				back: "Back to calendar",
				refresh: "Refresh",
				filter: "Filter",
				from: "From",
				to: "To",
				loading: "Loading…",
				empty: "No events in the selected period.",
				loadError: "Could not load the report.",
				notConnected: "Connect Google Calendar in Integrations to view the report.",
				colTitle: "Title",
				colDescription: "Description",
				colStart: "Start",
				colEnd: "End",
				colTicket: "Ticket",
				colName: "Name",
				colPhone: "Phone",
				colChannel: "Channel",
				colReferredBy: "Referred by",
				reminderScheduled: "Scheduled message",
				colSource: "Booked by",
				colStatus: "Status",
				sourceAi: "AI",
				sourceManual: "User",
				sourceSynced: "Google",
				statusFilter: "Status",
				statusAll: "All",
				statusScheduled: "Scheduled",
				statusCompleted: "Completed",
				statusCancelled: "Cancelled",
				statusPostponed: "Postponed",
				previewTitle: "Booking details",
				previewSubtitle: "Appointment preview and status change",
				close: "Close",
				saveStatus: "Save status",
				saving: "Saving…",
				statusSaved: "Status updated.",
				statusSaveError: "Could not update status.",
				changeStatus: "Change status",
				reason: "Reason",
				reasonOptional: "Reason (optional)",
				reasonPlaceholder: "Enter a reason",
				changedBy: "Changed by",
				openTicket: "Open ticket",
				searchName: "Name",
				searchTicket: "Ticket",
				searchPhone: "Phone",
				searchBookedBy: "Booked by",
				clearFilters: "Clear filters",
				countTotal: "Total",
				postponedBy: "Postponed by",
				newStart: "New start date/time",
				newEnd: "New end date/time",
				postponeRequired: "Enter the new date and time to postpone.",
				postponeInvalidRange: "End must be after start.",
			},
			transactions: {
				title: "Transactions",
				subtitle: "Asaas · PIX",
				loading: "Loading transactions…",
				empty: "No transactions found for the selected filters.",
				integrationMissing: "Asaas integration is not configured yet.",
				goToIntegrations: "Configure integration",
				summary: {
					total: "Total",
					totalHint: "Charges in the filtered period",
					pending: "Pending",
					pendingHint: "Awaiting payment",
					received: "Received",
					receivedHint: "Confirmed payments",
					receivedMonth: "Received this month",
					receivedMonthHint: "Sum of amounts received in the current month",
				},
				filters: {
					search: "Search",
					searchPlaceholder: "Contact, phone or payment ID…",
					period: "Period",
					periodAll: "All",
					periodToday: "Today",
					periodYesterday: "Yesterday",
					period7d: "Last 7 days",
					period30d: "Last 30 days",
					periodMonth: "This month",
					status: "Status",
					statusAll: "All",
				},
				status: {
					pending: "Pending",
					received: "Received",
				},
				columns: {
					date: "Date",
					contact: "Contact",
					amount: "Amount",
					status: "Status",
					dueDate: "Due date",
					paidAt: "Paid at",
					paymentId: "Payment ID",
				},
				pagination: {
					summary: "Showing {{from}} to {{to}} of {{total}} transaction(s)",
					prev: "Previous",
					next: "Next",
					aria: "Transactions pagination",
				},
				detail: {
					title: "Transaction details",
					receivedValue: "Received amount",
					pixCode: "PIX code",
					copyPix: "Copy PIX code",
					copyPixSuccess: "PIX code copied.",
					copyPixError: "Could not copy PIX code.",
					close: "Close",
					loadError: "Could not load transaction details.",
				},
			},
			adminAiReports: {
				title: "AI Report",
				subtitle: "Dynamic team insights powered by AI",
				formTitle: "Build report",
				formHint: "Set period, filters and focuses before generating the analysis.",
				historyTitle: "History",
				historyCount: "{{count}} report(s)",
				generate: "Generate report",
				generating: "Generating…",
				generatedSuccess: "Report generated successfully.",
				refresh: "Refresh",
				clear: "Clear filters",
				expand: "View",
				collapse: "Hide",
				emptyHistory: "No reports generated yet.",
				emptySelection: "Select a report",
				emptySelectionHint: "Pick an item on the left or generate a new analysis.",
				emptyQueues: "No queues found.",
				emptyUsers: "No agents found.",
				allQueues: "All queues",
				allUsers: "All agents",
				selectedCount: "{{count}} selected",
				questionPlaceholder: "E.g.: who handles customers best?",
				byAuthor: "by {{name}}",
				fields: {
					scope: "Report scope",
					periodType: "Period type",
					date: "Date",
					dateFrom: "From",
					dateTo: "To",
					queues: "Queues",
					users: "Agents",
					ticketId: "Ticket ID",
					contact: "Contact",
					focuses: "Analysis focuses",
					question: "Free question (optional)",
				},
				scope: {
					team: "Team / period",
					ticket: "Specific ticket",
					contact: "Contact (last 3 tickets)",
				},
				scopeHint: {
					team: "Analyzes operations in the period with queue and agent filters.",
					ticket: "Analyzes a single ticket by reading the conversation messages.",
					contact:
						"Analyzes the contact's last 3 tickets and the lead evolution.",
				},
				ticketPlaceholder: "E.g.: 12345",
				contactPlaceholder: "Search by name or number…",
				clearContact: "Change contact",
				searchingContacts: "Searching contacts…",
				emptyContacts: "No contacts found.",
				messagesScopeHint:
					"In this scope ticket messages are read automatically.",
				period: {
					day: "Day",
					hour: "Hourly range",
					month: "Month",
					custom: "Custom",
				},
				focuses: {
					sellers: "Agent performance",
					talk_time: "Talk time",
					quality: "Quality / CSAT",
					queue_volume: "Volume by queue",
					complaints: "What customers complain about most",
					people_improve: "How to improve the team",
					lead_interest: "Lead interest",
					lead_classification: "Lead classification",
					lead_helped: "Whether the service helped",
					messages: "Read ticket messages",
				},
				messagesHint:
					"Includes a sample of conversations in the analysis (slower and uses more tokens).",
				messagesAutoHint:
					"This focus already enables reading messages automatically.",
				result: {
					summary: "Summary",
					insights: "Insights",
					ranking: "Ranking",
					recommendations: "Team improvements",
				},
				lead: {
					temperature: "Temperature",
					score: "Lead score",
					helped: "Did service help?",
					classification: "Classification",
					nextStep: "Next step",
					objections: "Main objections",
					funnel: "Funnel / alignment",
					tags: "Contact tags",
					noObjections: "No clear objections identified.",
					noFunnel: "No funnel stage linked.",
					noTags: "No tags on this contact.",
					tempValues: {
						quente: "Hot",
						morno: "Warm",
						frio: "Cold",
						indefinido: "Undefined",
					},
					helpedValues: {
						sim: "Yes",
						parcial: "Partial",
						nao: "No",
						indefinido: "Undefined",
					},
					classificationValues: {
						boa: "Good",
						ruim: "Bad",
						duvidosa: "Doubtful",
						indefinido: "Undefined",
					},
				},
				errors: {
					needFocus: "Select at least one focus.",
					needDates: "Provide the date range.",
					needTicket: "Enter the ticket ID.",
					needContact: "Select a contact.",
				},
			},
			socialComments: {
				title: "Comments",
				emptyList: "No comments found.",
				searchPlaceholder: "Search comments…",
				loading: "Loading comments…",
				loadError: "Could not load comments.",
				commentsCount: "{{count}} comment(s)",
				loadMore:"Loading more",
				loadMoreComments: "Load more comments",
				loadingMoreComments: "Loading comments…",
				viewComments: "View comments",
				viewOriginal: "View original post",
				emptyComments: "No comments on this post.",
				filters: {
					channel: "Channel",
					status: "Status",
					all: "All",
					facebook: "Facebook",
					instagram: "Instagram",
					tiktok: "TikTok",
					mercadolivre: "Mercado Livre",
					statusAll: "All",
				},
				status: {
					open: "Open",
					replied: "Replied",
				},
				actions: {
					reply: "Reply",
					markReplied: "Mark as replied",
					reopen: "Reopen",
				},
				mock: {
					banner: "Fictional data for demonstration — does not reflect real comments.",
				},
				reply: {
					placeholder: "Write your reply…",
					success: "Reply sent (local simulation).",
				},
			},
			permissionModal: {
				title: "Action unauthorized",
				content: "You don't have permission to perform this action.",
			},
			whatsappModal: {
				title: {
					add: "Add Connection",
					edit: "Edit Connection",
				},
				form: {
					name: "Connection name",
					default: "Default",
					channel: "Channel",
					farewellMessage: "Farewell message",
					whatsapp: "WhatsApp",
					facebook: "Facebook",
					telegram: "Telegram",
					instagram: "Instagram",
					whatsappcloud: "WhatsApp API",
					connectionInfo: "Connection Info",
					connectionInfoHint: "Connection creation and last update dates.",
					createdAt: "Created on",
					updatedAt: "Updated on",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
			},
			qrCode: {
				title: `To use  ${process.env.REACT_APP_NOME}:`,
				firstPoint: "Open WhatsApp on your mobile.",
				secondPoint: {
					partOne: "Tap on ",
					moreOptions: "More Options ",
					partTwo: " or ",
					configurations: "Settings ",
					partThree: "and select Connected Devices.",
				},
				thirdPoint: "Tap Connect a device.",
				fourthPoint:
					"Point your cell phone at this screen to capture the code.",
				message: "Read QRCode to start the sessions",
				waiting: "Waiting for QR Code...",
			},
			contacts: {
				title: "Contacts",
				subtitle: "Management",
				listTitle: "Contacts list",
				toasts: {
					deleted: "Contact deleted sucessfully!",
					deletedSelected: "Selected contacts deleted successfully.",
				},
				selectAll: "Select all in list",
				selectRow: "Select {{name}}",
				selectedCount: "{{count}} selected",
				searchPlaceholder: "Search name, email or number...",
				filterTagsPlaceholder: "Filter by tags",
				filterTagsSelectedCount: "{{count}} tags selected",
				filterTagsClear: "Clear selection",
				empty: "No contacts found.",
				emptyHint: "Try another search term or filter.",
				pagination: {
					label: "Pagination",
					showing: "Showing {{start}}–{{end}} of {{total}}",
					previous: "Previous",
					next: "Next",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					importTitlte: "Import contacts",
					deleteMessage:
						"Are you sure you want to delete this contact? All related tickets will be lost.",
					deleteSelectedTitle: "Delete selected contacts?",
					deleteSelectedMessage:
						"{{count}} contact(s) will be deleted. All related tickets will be lost.",
					importMessage: "Do you want to import all contacts from the phone?",
				},
				buttons: {
					import: "Import",
					export: "Export",
					add: "Add contact",
					deleteSelected: "Delete selected",
					chat: "Chat",
					edit: "Edit",
					delete: "Delete",
				},
				table: {
					name: "Name",
					tags: "Tags",
					whatsapp: "WhatsApp",
					email: "Email",
					company: "Company",
					actions: "Actions",
				},
			},
			contactModal: {
				title: {
					add: "Add contact",
					edit: "Edit contact",
				},
				form: {
					connection: "Connection",
					mainInfo: "Contact details",
					extraInfo: "Additional information",
					name: "Name",
					number: "Whatsapp number",
					numberHint: "Country code (55 for Brazil) and number with area code (e.g. 13912344321).",
					ddi: "Country code",
					ddiRequired: "Enter the country code (e.g. 55).",
					numberBrInvalid: "Enter area code + number (10 or 11 digits, e.g. 13912344321).",
					numberInvalid: "Invalid number for the given country code.",
					numberDigitsOnly: "Enter digits only.",
					email: "Email",
					company: "Company",
					extraName: "Field name",
					extraValue: "Value",
				},
				buttons: {
					addExtraInfo: "Add information",
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
			},
			contactsImportModal: {
				title: "Import contacts",
				success: "Contacts imported successfully.",
				steps: {
					upload: "Upload file",
					mapping: "Field mapping",
					import: "Import",
				},
				buttons: {
					cancel: "Cancel",
					back: "Back",
					continue: "Continue",
					import: "Import",
				},
				stepOne: {
					intro: "Upload a CSV file with the contacts you want to add.",
					hint: "If your file is in another format, open it in Excel and export as CSV.",
					downloadSample: "Download a sample CSV file",
					filePlaceholder: "Insert CSV file",
					browse: "Browse",
					selectedCount: "{{count}} contacts selected",
					warning:"Contact limit per CSV: 1000"
				},
				stepTwo: {
					intro: "Select the variables that match the CSV columns.",
					name: "Contact name (required)",
					number: "Contact number (required)",
					email: "Contact email",
					select: "Select column",
					none: "None",
				},
				stepThree: {
					intro: "Confirm the field mapping with the sample below.",
				},
			},
			contactsExportModal: {
				titleExporting: "Exporting contacts",
				titleDone: "Operation completed",
				exporting: "Please wait while the file is being generated…",
				done: "Contacts exported: {{count}}",
				close: "Close",
			},
			bulkMessaging: {
				title: "Bulk messaging",
				subtitle: "Manage batch message campaigns",
				listTitle: "Campaigns",
				empty: "No campaigns yet.",
				confirmDeleteTitle: "Delete bulk send?",
				buttons: { add: "Add bulk send" },
				toasts: { deleted: "Bulk send deleted!", updated: "Bulk send updated!" },
				table: {
					protocol: "Protocol",
					name: "Name",
					sendDate: "Send date",
					estimatedEnd: "Estimated end",
					status: "Status",
					actions: "Actions",
				},
				status: {
					stopped: "Paused",
					running: "Running",
					unstarted: "Not started",
					cancelled: "Cancelled",
					complete: "Complete",
				},
				actions: {
					edit: "Edit",
					start: "Start",
					pause: "Pause",
					resume: "Resume",
					resendAll: "Resend all",
					resendAllHint: "Re-enqueues only contacts without confirmed delivery",
					resendFailed: "Resend {{count}} failed",
					loading: "Loading…",
					details: "Details",
					duplicate: "Duplicate",
					delete: "Delete",
				},
				infoModal: {
					title: "Send report",
					close: "Close",
					name: "Name",
					contact: "Contact",
					status: "Status",
					attempts: "Attempts",
					sent: "Sent",
					notSent: "Failed",
					pending: "Pending",
					summarySuccess: "Success",
					summaryFailed: "Failed",
					summaryPending: "Pending",
					tabAll: "All",
					tabSuccess: "Sent",
					tabFailed: "Failed",
					tabPending: "Pending",
					errorReason: "Reason",
					empty: "No contacts in this send.",
				},
				variablesModal: {
					title: "Message variables",
					hint: "Click a variable to insert it into the message.",
					close: "Close",
				},
				modal: {
					titleAdd: "Create bulk message send",
					titleEdit: "Edit bulk message send",
					steps: {
						campaign: "Campaign setup",
						contacts: "Select recipients",
						review: "Review",
					},
					back: "Back",
					continue: "Continue",
					finish: "Finish",
					reset: "Reset",
					allStepsDone: "All steps completed.",
				},
				wizard: {
					pageTitleAdd: "New campaign",
					pageTitleEdit: "Edit campaign",
					breadcrumbList: "Bulk messaging",
					backToList: "Campaign list",
					previousStep: "Previous step",
					contactsStep: {
						intro: "Choose how to add recipients: select existing contacts or import a CSV list.",
						tabRegistered: "Registered contacts",
						tabImport: "Import list",
						panelIncluded: "Campaign contacts",
						panelAvailable: "Available contacts",
						selectHint: "Select contacts and click add.",
						importHint: "Upload a .csv, .xlsx or .xls file with name and number columns. Only valid phone numbers will be imported.",
						downloadSample: "Download sample file",
						filePlaceholder: "No file selected",
						browse: "Choose file",
						addSelected: "Add to campaign ({{count}})",
						selectedTitle: "Campaign contacts ({{count}})",
						manualTitle: "Or add a single number",
						contactName: "Contact name",
						contactNumber: "Number (with country code)",
						numberExample: "Example: 5527998851972",
						numberExampleShort: "5527998851972",
						numberInvalid: "Use 12 or 13 digits with country code",
						addManual: "Add",
						removeSelected: "Remove selected ({{count}})",
						searchedCount: "Found: {{count}}",
						searchPlaceholder: "Name or number",
						searchInputPlaceholder: "Search by name or number",
						clearSearch: "Clear search",
						searchTags: "Tags",
						searchButton: "Search",
						importEmpty: "The file is empty or invalid.",
						importInvalidColumns: "The file must have name and number columns (or nome and número).",
						importUnsupportedType: "Unsupported format. Use .csv, .xlsx or .xls.",
						importNoRows: "No valid contacts found in the file.",
						importSuccess: "{{count}} contact(s) imported to the campaign.",
						importPartialSuccess:
							"{{valid}} contact(s) imported. {{invalid}} row(s) skipped due to errors.",
						importRejectedTitle: "{{count}} row(s) not imported",
						importRejectedLine: "Line",
						importRejectedReason: "Reason",
						importRejectReasons: {
							emptyName: "Empty name",
							emptyNumber: "Empty number",
							invalidNumber: "Not a valid phone number",
							duplicate: "Duplicate number in file",
							alreadyInCampaign: "Already in campaign",
						},
						importError: "Could not read the file.",
						importAddedHint: "{{count}} contact(s) added. See them in the column on the right.",
						emptyCampaign: "No contacts in the campaign yet.",
						emptyAvailable: "No contacts found. Adjust search or tags.",
						loadingContacts: "Loading contacts...",
					},
				},
			},
			quickAnswersModal: {
				title: {
					add: "Add Quick Reply",
					edit: "Edit Quick Answer",
				},
				form: {
					shortcut: "Shortcut",
					message: "Message",
					attachImage: "Attach image",
					removeImage: "Remove image",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Quick Reply saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add queue",
					edit: "Edit queue",
				},
				notification: {
					title: "Sector saved successfully!",
					chatbotAdded: "Chatbot linked to the queue successfully!",
					saveBeforeChatbot: "Save the queue before linking the chatbot.",
				},
				form: {
					name: "Name",
					color: "Color",
					greetingMessage: "Greeting Message",
					startWork: "Opening",
					endWork: "Close",
					absenceMessage: "Absence message",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
			},
			userModal: {
				title: {
					add: "Add user",
					edit: "Edit user",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
					profile: "Profile",
					whatsapp: "Default Connection",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			chat: {
				noTicketMessage: "Select a ticket to start chatting.",
				noChatDescription:
					"Send and receive messages without having to keep your phone connected to the internet",
				noChatDescriptionText:
					`Use  ${process.env.REACT_APP_NOME} on as many computers as you want and a cell phone at the same time.`,
				layout: {
					tryNewExperience: "New experience",
					tryNewExperienceSub: "Modern chat layout",
					newExperienceBadge: "New",
					newExperienceActive: "New experience on",
					backToClassicShort: "Back",
					backToClassic: "Back to classic layout",
					classicLayoutRailLabel: "Classic layout",
					toggleHint:
						"Changes only the chat visual layout. Company list mode (legacy/new) is still set in Settings.",
					switched: "Chat layout updated.",
					chatsTitle: "Chats",
					openSection: "Open tickets",
					backToList: "Chats",
					selectConversationHint: "Select a conversation from the list.",
					searchPlaceholder: "Search or start a conversation",
					newConversation: "New conversation",
					recentChats: "Recent Chats",
					allConversations: "All Conversations",
					pendingSection: "Pending tickets",
					closedSection: "Closed",
					statusSection: "Status",
					filters: "Filters",
					filterAll: "All",
					filterUnread: "Unread",
					filterChannel: "Channels",
					filterChannelEmpty: "No channel found",
					selectFilterChannel: "Select channels",
					filterUnreadWithCount: "Unread, {{count}} unread messages",
					filterGroups: "Groups",
					filterSort: "Sort",
					filterSortAsc: "Oldest first",
					filterSortDesc: "Newest first",
					filterQueues: "Queues",
					filterTags: "Tags",
					filterQueuesEmpty: "No queues available",
					filterTagsEmpty: "No tags available",
					filterTagsSearch: "Search tags...",
					filterTagsPlaceholder: "Select tags",
					filterTagsNoResults: "No tags found",
					filterClearAll: "Clear",
					filterApply: "Apply",
					salesFunnel: "Sales funnel",
					loadMore: "Load more",
					loadingMore: "Loading...",
				},
			},
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			tickets: {
				toasts: {
					deleted: "The ticket you were on has been deleted.",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
				},
				search: {
					placeholder: "Search tickets and messages.",
					recentTitle: "Recent",
					recentClear: "Clear all",
					recentRemove: "Remove search",
				},
				buttons: {
					showAll: "All",
				},
			},
			templateOnlyBar: {
				message:
					"Outside Meta's 24-hour window. Send a template to continue the conversation.",
			},
			transferTicketModal: {
				title: "Transfer Ticket",
				fieldLabel: "Type to search for users",
				fieldQueueLabel: "Transfer to queue",
				fieldConnectionLabel: "Transfer to connection",
				fieldQueuePlaceholder: "Please select a queue",
				fieldConnectionPlaceholder: "Please select a connection",
				noOptions: "No user found with this name",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
			},
			statusList: {
				title: "WhatsApp Status",
				subtitle: "Tap a contact to view their status update.",
				viewStatus: "View status",
				published: "Status published",
				unavailable: "Status media unavailable",
				emptyTitle: "No statuses right now",
				emptyMessage:
					"When contacts post statuses, they will appear here. Enable “Profile status” in Settings.",
			},
			ticketsList: {
				pendingHeader: "Queue",
				assignedHeader: "Working on",
				noTicketsTitle: "Nothing here!",
				connectionTitle: "Connection that is currently being used.",
				noTicketsMessage: "No tickets found with this status or search term.",
				items: {
					queueless: "Without Sector",
					accept: "Accept",
					spy: "Spy",
					close: "Close",
					reopen: "Reopen",
				},
				buttons: {
					accept: "Reply",
					acceptBeforeBot: "Accept",
					start: "start",
					cancel: "Cancel",
				},
				acceptModal: {
					title: "Accept Chat",
					queue: "Select sector",
				},
			},
			newTicketModal: {
				title: "Create Ticket",
				fieldLabel: "Type to search for a contact",
				add: "Add",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
			},
			master: {
				layout: {
					title: "Master Panel",
					subtitle: "System administration",
					toggleMenu: "Toggle menu",
					closeMenu: "Close menu",
					toggleTheme: "Toggle theme",
					searchPlaceholder: "Search...",
					ModalIa:"AI manager"
				},
				nav: {
					dashboard: "Dashboard",
					companies: "Companies",
					plans: "Plans",
					addons: "One-off purchases",
					coupons: "Coupons",
					finance: "Finance",
					system: "Server analysis",
					documents: "Bulletins",
					searchUsers: "Users by company",
					scheduleLogs: "Schedule logs",
					bulkMessagingLogs: "Bulk messaging logs",
					sectionOverview: "Overview",
					sectionCommercial: "Commercial",
					sectionSystem: "System",
					sectionLogs: "Logs",
				},
				documents: {
					pageTitle: "Bulletins",
					pageSubtitle: "Notices, Meta, updates and events for companies",
				},
				plans: {
					pageTitle: "Plans",
					pageSubtitle: "System plans catalog",
					listTitle: "Registered plans",
					countLabel: "records",
					loading: "Loading plans...",
					empty: "No plans registered",
					emptyHint: "Create the first plan to make it available in the catalog.",
					create: "New plan",
					createTitle: "New plan",
					editTitle: "Edit plan",
					edit: "Edit",
					delete: "Delete",
					close: "Close",
					cancel: "Cancel",
					save: "Save",
					saving: "Saving...",
					fieldName: "Name",
					fieldPriceMonthly: "Monthly price",
					fieldPriceQuarterly: "Quarterly price",
					fieldPriceSemiannual: "Semiannual price",
					fieldPriceAnnual: "Annual price",
					fieldMonthlyTokens: "Monthly tokens",
					fieldActive: "Active in catalog",
					pricesHint: "Set the price for each billing cycle on the same plan.",
					colName: "Name",
					colPriceMonthly: "Monthly",
					colPriceQuarterly: "Quarterly",
					colPriceSemiannual: "Semiannual",
					colPriceAnnual: "Annual",
					colMonthlyTokens: "Tokens/month",
					tokensShort: "tokens/mo",
					perMonth: "per month",
					statTotal: "Total plans",
					statActive: "Active plans",
					statInactive: "Inactive plans",
					colStatus: "Status",
					colActions: "Actions",
					confirmDelete: "Remove plan \"{{name}}\"?",
					confirmDeleteMessage: "If the plan is linked to companies, it will only be deactivated.",
					toastCreated: "Plan created.",
					toastUpdated: "Plan updated.",
					toastDeleted: "Plan removed.",
					toastDisabled: "Plan disabled (companies are linked).",
				},
				addons: {
					pageTitle: "One-off purchases",
					pageSubtitle: "Additional packages catalog (tokens and other items)",
					listTitle: "Registered packages",
					countLabel: "records",
					loading: "Loading packages...",
					empty: "No packages registered",
					emptyHint: "Create the first additional token package.",
					create: "New package",
					createTitle: "New package",
					editTitle: "Edit package",
					edit: "Edit",
					delete: "Delete",
					cancel: "Cancel",
					save: "Save",
					saving: "Saving...",
					fieldName: "Name",
					fieldQuantity: "Token quantity",
					fieldPrice: "Price",
					fieldActive: "Active in catalog",
					formHint: "Additional token package with no expiration.",
					typeTokens: "Tokens",
					tokensUnit: "tokens",
					statTotal: "Total packages",
					statActive: "Active packages",
					statInactive: "Inactive packages",
					confirmDelete: "Remove package \"{{name}}\"?",
					confirmDeleteMessage: "If the package is linked to purchases, it will only be deactivated.",
					toastCreated: "Package created.",
					toastUpdated: "Package updated.",
					toastDeleted: "Package removed.",
					toastDisabled: "Package disabled (purchases are linked).",
				},
				coupons: {
					pageTitle: "Coupons",
					pageSubtitle: "Discount coupons for purchases and subscriptions",
					listTitle: "Registered coupons",
					countLabel: "records",
					loading: "Loading coupons...",
					empty: "No coupons registered",
					emptyHint: "Create the first discount coupon.",
					create: "New coupon",
					createTitle: "New coupon",
					editTitle: "Edit coupon",
					edit: "Edit",
					delete: "Delete",
					cancel: "Cancel",
					save: "Save",
					saving: "Saving...",
					fieldName: "Code",
					fieldDiscountType: "Discount type",
					fieldDiscountValue: "Discount value",
					fieldExpiresAt: "Expiration",
					fieldLifetime: "Lifetime (no expiration)",
					fieldEmailRef: "Restricted email",
					fieldActive: "Active in catalog",
					formHint: "Unique code. Leave email empty for general use.",
					emailHint: "Optional. If set, the coupon applies only to this email.",
					typePercentage: "Percentage",
					typeFixed: "Fixed amount",
					noExpiry: "Lifetime",
					anyEmail: "Any email",
					statTotal: "Total coupons",
					statActive: "Active coupons",
					statInactive: "Inactive coupons",
					confirmDelete: "Remove coupon \"{{name}}\"?",
					confirmDeleteMessage: "If the coupon is linked to plans, it will only be deactivated.",
					toastCreated: "Coupon created.",
					toastUpdated: "Coupon updated.",
					toastDeleted: "Coupon removed.",
					toastDisabled: "Coupon disabled (plans are linked).",
				},
				finance: {
					pageTitle: "Finance",
					pageSubtitle: "Purchases, subscriptions and coupon usage",
					periodPreset: "Period",
					period30: "Last 30 days",
					period90: "Last 90 days",
					periodMonth: "Current month",
					periodAll: "All time",
					periodCustom: "Custom",
					from: "From",
					to: "To",
					kpiRevenuePaid: "Paid revenue (tokens)",
					kpiRevenuePending: "Pending (tokens)",
					kpiSubsActive: "Active subscriptions",
					kpiSubsWithCoupon: "Subscriptions with coupon",
					revenueChart: "Paid revenue by month",
					noChartData: "No revenue data in this period.",
					purchasesByStatus: "Summary",
					statusPaid: "Paid",
					statusPending: "Pending",
					statusCanceled: "Canceled",
					statusActive: "Active",
					statusExpired: "Expired",
					statusInactive: "Inactive",
					subsCanceled: "Canceled subscriptions",
					subsExpired: "Expired subscriptions",
					tab: {
						purchases: "One-off purchases",
						subscriptions: "Subscriptions",
						coupons: "Coupons",
					},
					allStatuses: "All statuses",
					allCoupons: "All subscriptions",
					onlyWithCoupon: "With coupon only",
					emptyPurchases: "No purchases found.",
					emptySubscriptions: "No subscriptions found.",
					emptyCoupons: "No coupon usage found.",
					colCompany: "Company",
					colAddon: "Package",
					colTotal: "Total",
					colDiscount: "Discount",
					colStatus: "Status",
					colPaymentId: "Payment ID",
					colDate: "Date",
					colPlan: "Plan",
					colTokens: "Tokens used",
					colCoupon: "Coupon",
					colStarted: "Started",
					colExpires: "Expires",
					colUsage: "Uses",
					colLastUsed: "Last used",
					records: "records",
					prev: "Previous",
					next: "Next",
				},
				scheduleLogs: {
					pageTitle: "Schedule logs",
					pageSubtitle: "Scheduled send warnings and errors (Go/Redis)",
					trackPageTitle: "Schedule trace",
					trackBreadcrumb: "Trace",
					listTitle: "Warning and error records",
					records: "records",
					allCompanies: "All companies",
					filterScheduleId: "Schedule ID",
					allLevels: "All levels",
					levelError: "Error",
					levelWarn: "Warning",
					allEvents: "All events",
					searchMessage: "Search in message...",
					empty: "No logs found with the current filters.",
					colDate: "Date/time",
					colSchedule: "Schedule",
					colCompany: "Company",
					colEvent: "Event",
					colLevel: "Level",
					colMessage: "Message",
					colStatus: "Status",
					colActions: "Actions",
					viewTrack: "View trace",
					showing: "Showing {{start}}–{{end}} of {{total}}",
					prev: "Previous",
					next: "Next",
					trackTitle: "Execution trace",
					scheduleId: "Schedule",
					close: "Close",
					sendAt: "Send at",
					contactId: "Contact",
					lastError: "Last error",
					noLogsForSchedule: "No logs recorded for this schedule.",
					traceTitle: "Steps until failure",
					channel: "Channel",
				},
				bulkMessagingLogs: {
					pageTitle: "Bulk messaging logs",
					pageSubtitle: "Bulk send warnings and errors (Go/Asynq)",
					trackPageTitle: "Campaign trace",
					trackBreadcrumb: "Trace",
					listTitle: "Warning and error records",
					records: "records",
					allCompanies: "All companies",
					filterBulkId: "Campaign ID",
					filterContactNumber: "Contact number",
					allLevels: "All levels",
					levelError: "Error",
					levelWarn: "Warning",
					allEvents: "All events",
					searchMessage: "Search in message...",
					empty: "No logs found with the current filters.",
					colDate: "Date/time",
					colBulk: "Campaign",
					colNumber: "Number",
					colCompany: "Company",
					colEvent: "Event",
					colLevel: "Level",
					colMessage: "Message",
					colStatus: "Status",
					colName: "Name",
					colActions: "Actions",
					viewTrack: "View trace",
					showing: "Showing {{start}}–{{end}} of {{total}}",
					prev: "Previous",
					next: "Next",
					trackTitle: "Execution trace",
					bulkId: "Campaign",
					close: "Close",
					protocol: "Protocol",
					contactNumber: "Number",
					lastError: "Last error",
					noLogsForBulk: "No logs recorded for this campaign.",
					traceTitle: "Steps until failure",
					channel: "Channel",
					statsSuccess: "Sent",
					statsFailed: "Failed",
					statsPending: "Pending",
				},
				system: {
					cpu: "Processor (CPU)",
					ram: "Memory (RAM)",
					storage: "Storage",
					uptime: "Uptime",
					free: "Free",
					usage: "Usage",
					cores: "cores",
					volumes: "Disk volumes",
					volumeCount: "volumes",
					mount: "Mount",
					fs: "Filesystem",
					capacity: "Capacity",
					loading: "Loading server metrics...",
					loadError: "Failed to load system information.",
					retry: "Try again",
					refreshing: "Refreshing",
				},
				dashboard: {
					totalCompanies: "Total companies",
					activeCompanies: "Active companies",
					totalUsers: "Total users",
					totalConnections: "Total connections",
					active: "Active",
					inactive: "Inactive",
					registrationsChart: "Registrations per month",
					statusChart: "Company status",
					topCompaniesChart: "Top companies by users",
					noChartData: "No data to display",
					systemCardTitle: "Server health",
					systemCardLink: "View full analysis",
					memory: "Memory",
					disk: "Disk",
				},
				pages: {
					dashboardTitle: "Dashboard",
					dashboardSubtitle: "System overview and company metrics",
					companiesTitle: "Companies",
					statusActive: "Active",
					statusInactive: "Inactive",
					editCompany: "Edit",
					companiesListTitle: "Registered companies",
					companiesListSubtitle: "All companies in the system",
					companiesCountLabel: "records",
					companiesSearchPlaceholder: "Search by name, document or ID",
					companiesFilterAll: "All statuses",
					companiesShowing: "Showing {{start}}–{{end}} of {{total}} results",
					colCompany: "Company",
					colUsers: "Users",
					colLimit: "Limit",
					colConnections: "Connections",
					colContractDueDate: "Due date",
					colContractValue: "Value",
					colContractDetails: "Contract details",
					colStatus: "Status",
					colCreated: "Created",
					colActions: "Actions",
					activate: "Activate",
					deactivate: "Deactivate",
					masterCompanyLocked: "The system Master company cannot be deactivated.",
					masterCompanyBadge: "System",
					systemTitle: "System analysis",
					systemSubtitle: "Server CPU, memory and storage · auto-refresh every 30s",
					systemLastUpdate: "Last update",
					systemRefresh: "Refresh now",
					searchUsersTitle: "Users by company",
					searchUsersSubtitle: "Select a company to list its users",
					searchUsersCompanyLabel: "Company",
					searchUsersSelectCompany: "Select a company",
					searchUsersSearchLabel: "Search",
					searchUsersPlaceholder: "Name, email or ID...",
					searchUsersListTitle: "Company users",
					searchUsersCountLabel: "records",
					searchUsersStatTotal: "Users found",
					searchUsersNoCompany: "No company selected",
					searchUsersNoCompanyHint: "Choose a company above to view its users.",
					searchUsersLoading: "Loading users...",
					searchUsersEmpty: "No users found",
					searchUsersEmptyHint: "Try a different search term.",
					searchUsersShowing: "Showing {{start}}–{{end}} of {{total}}",
					colUser: "User",
					colEmail: "Email",
					colProfile: "Profile",
					companyOwner: "Owner",
					profile_user: "Agent",
					profile_admin: "Administrator",
					profile_master: "Master",
					editCompanyTitle: "Edit company",
					contractSectionTitle: "Contract",
					contractSectionHint: "Commercial notes and due date filled in manually.",
					contractDetailsLabel: "Contract details",
					contractDetailsHint: "Record what was agreed with the client (plan, terms, notes).",
					contractDetailsPlaceholder: "E.g.: Annual plan with 5 users and priority support...",
					contractDueDateLabel: "Due date",
					contractDueDateHint: "Date when the contract or license expires.",
					contractValueLabel: "Contract value",
					contractValueHint: "Amount agreed with the client (informational, manual entry).",
					contractValuePlaceholder: "E.g.: 1500.00",
					viewContractDetails: "View contract details",
					contractDetailsReadOnlyLabel: "Contract notes",
					noContractDetails: "No details registered for this company.",
					loading: "Loading...",
					loadingCompany: "Loading company data...",
					saving: "Saving...",
					passwordOptional: "Leave blank to keep current password.",
					loadingCompanies: "Loading companies...",
					noCompanies: "No companies registered",
					noCompaniesHint: "Companies will appear here when created.",
					viewCompany: "View company",
					viewCompanySubtitle: "Details and contact",
					viewPlanNameLabel: "Plan",
					previous: "Previous",
					next: "Next",
					pageOf: "Page {{page}} of {{total}}",
					companiesRange: "{{start}}–{{end}} of {{total}} companies",
				},
				editCompany: {
					planSectionTitle: "Plan / tokens",
					planSectionHint:
						"Set a catalog plan or a custom plan and the monthly token quota. Billing amount stays under Contract value.",
					planModeLabel: "Mode",
					planModeCatalog: "Catalog",
					planModeCustom: "Custom",
					planCatalogLabel: "Catalog plan",
					planCatalogPlaceholder: "Select a plan",
					planCustomNameLabel: "Plan name",
					planCustomNamePlaceholder: "E.g.: Custom corporate plan",
					planMonthlyTokensLabel: "Monthly token quota",
					planMonthlyTokensHint: "Can override the catalog plan default quota.",
					planExpiresAtLabel: "Plan validity",
					planExpiresAtHint: "Optional. Leave blank if there is no expiration.",
					planStatusLabel: "Status",
					planStatusActive: "Active",
					planStatusCanceled: "Canceled",
					planStatusExpired: "Expired",
					planUsedTokens: "Used tokens",
					planExtraTokens: "Extra tokens",
					planRemainingTokens: "Remaining tokens",
					planNoActive: "No active plan. Save to create one.",
					planSave: "Save plan",
					planSaving: "Saving plan...",
					planSaved: "Plan updated successfully.",
					planLoadError: "Could not load catalog plans.",
					planCustomNameRequired: "Enter a custom plan name (min. 2 characters).",
					companyAndPlanSaved: "Company and plan updated successfully.",
				},
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Connections",
					tickets: "Conversations",
					socialComments: "Comments",
					contacts: "Contacts",
					quickAnswers: "Quick Answers",
					documentation: "Bulletins",
					queues: "Queues",
					tags: "Tags",
					schedules: "Schedules",
					googleAgenda: "Google Calendar",
					administration: "Administration",
					followUp: "Follow-up",
					users: "Users",
					settings: "Settings",
					api: "API usage",
					apidocs: "Documentation",
					apititle: "API",
					apikey: "API Key",
					token: "Token",
					salesFunnel: "Sales funnel",
				},
				appBar: {
					user: {
						profile: "Profile",
						logout: "Logout",
					},
				},
			},
			notifications: {
				noTickets: "No notifications.",
			},
			layout: {
				topbarSearch: {
					placeholder: "Search pages, contacts and conversations...",
					pages: "Pages",
					contacts: "Contacts",
					tickets: "Conversations",
					noResults: "No results found.",
					loading: "Searching...",
					systemVersion: "System version",
				},
			},
			followUp: {
				title: "Follow-up",
				adminSubtitle: "Administration",
				listTitle: "Rules by queue",
				listHint: "If the last message is yours (agent) and the customer does not reply, the system sends the text and then applies the action.",
				loading: "Loading queues…",
				empty: "No queues found.",
				enabled: "Enabled",
				disabled: "Disabled",
				modalTitle: "Configure follow-up",
				modalHint: "Follow-up starts after you send a message. The action runs only if the customer still does not reply.",
				summary: {
					active: "Queues with follow-up",
					activeHint: "Active rules right now.",
					how: "How it works",
					howHint: "1) You send a message. 2) If the customer does not reply in X hours, send the follow-up. 3) If they still do not reply, apply the action.",
				},
				table: {
					queue: "Queue",
					status: "Status",
					delays: "Delays (msg / action)",
					action: "Action",
					actions: "Actions",
				},
				fields: {
					enabled: "Enable follow-up for this queue",
					body: "Message",
					bodyPlaceholder: "Hi, are you still there? Can I help with anything else?",
					messageHours: "Hours until the message",
					actionHours: "Hours until the action after the message",
					action: "Action if there is no reply",
					targetQueue: "Target queue",
					targetUser: "Target user",
					none: "None",
					closeMode: "When closing the ticket",
					closeSilent: "Close without sending a message",
					closeSilentHint: "The ticket is resolved and the customer gets nothing besides the follow-up already sent.",
					closeFarewell: "Close with farewell and rating",
					closeFarewellHint: "Sends the connection farewell message and the support rating link.",
					tags: "Tags after the action",
					tagsHint: "Optional. Applied to the ticket/contact if the customer does not reply and the action runs. Leave empty for no tags.",
					tagsEmpty: "No tags found.",
				},
				actionPending: "Move to pending",
				actionClose: "Close ticket",
				actionChangeQueue: "Change queue",
				actionTransferUser: "Transfer to a user",
				buttons: {
					configure: "Configure",
					save: "Save",
					saving: "Saving…",
					cancel: "Cancel",
				},
				toasts: {
					saved: "Follow-up saved.",
				},
				errors: {
					bodyRequired: "Enter a message to enable follow-up.",
					queueRequired: "Choose the target queue.",
					userRequired: "Choose the target user.",
				},
			},
			queues: {
				title: "Queues",
				notifications: {
					queueDeleted: "Queue deleted successfully.",
				},
				table: {
					name: "Name",
					color: "Color",
					greeting: "Greeting message",
					actions: "Actions",
					startWork: "Opening",
					endWork: "Close",
				},
				buttons: {
					add: "Add queue",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? This action cannot be undone. Tickets in this queue will still exist, but they will no longer have a queue assigned.",
				},
			},
			queueSelect: {
				inputLabel: "Queues",
			},
			autoQueueSelect: {
				inputLabel: "Chatbot: Automatic queue selection",
				empty: "No queue selected",
			},
			chatbotMaxAttempts: "Chatbot: Maximum attempts",
			quickAnswers: {
				title: "Quick Answers",
				subtitle: "Message shortcuts for use in conversations",
				listTitle: "Quick answers list",
				empty: "No quick replies found.",
				emptyHint: "Try a different search term.",
				pagination: {
					label: "Pagination",
					showing: "Showing {{start}}–{{end}} of {{total}}",
					previous: "Previous",
					next: "Next",
				},
				selectAll: "Select all in list",
				selectRow: "Select {{shortcut}}",
				selectedCount: "{{count}} selected",
				table: {
					shortcut: "Shortcut",
					message: "Message",
					file: "File",
					hasFile: "Yes",
					actions: "Actions",
				},
				buttons: {
					add: "Add quick reply",
					deleteSelected: "Delete selected",
					edit: "Edit",
					delete: "Delete",
				},
				toasts: {
					deleted: "Quick answer deleted successfully.",
					deletedSelected: "Selected quick replies deleted successfully.",
				},
				searchPlaceholder: "Search...",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this quick answer: ",
					deleteMessage: "This action cannot be undone.",
					deleteSelectedTitle: "Delete selected quick replies?",
					deleteSelectedMessage:
						"{{count}} quick reply(ies) will be deleted. This action cannot be undone.",
				},
			},
			users: {
				title: "Users",
				table: {
					name: "Name",
					email: "Email",
					profile: "Profile",
					whatsapp: "Default Connection",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
				},
				toasts: {
					deleted: "User deleted successfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"All user data will be lost. This user's open tickets will be moved to the queue.",
				},
			},
			templates: {
				title: "Templates",
				table: {
					type: "Type",
					status: "Status",
					name: "Name",
					email: "Email",
					category: "Category",
					profile: "Profile",
					whatsapp: "Default Connection",
					actions: "Actions",
					header: "Header",
					body: "Body",
					footer: "Footer",
					statuses: {
						APPROVED: "Approved",
						PENDING: "Pending",
						REJECTED: "Rejected",
					},
					types: {
						UTILITY: "Utility",
						MARKETING: "Marketing",
						AUTHENTICATION: "Authentication",
					},
				},
				buttons: {
					add: "Add template",
				},
				toasts: {
					deleted: "Template deleted successfully.",
				},
				templateModal: {
					title: {
						create: "Add template",
						update: "Edit template",
					},
					connection: "Connection",
					name: "Name",
					header: "Header",
					body: "Body",
					footer: "Footer",
					buttons: {
						create: "Create",
						update: "Update",
						cancel: "Cancel",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "All template information will be lost.",
				},
			},
			schedules: {
				title: "Schedules",
				subtitle: "Organize scheduled messages and follow delivery status.",
				listTitle: "Schedules list",
				searchPlaceholder: "Search schedule...",
				empty: "No schedules found.",
				emptyHint: "Try a different search term.",
				templateLabel: "Template: {{id}}",
				pagination: {
					label: "Pagination",
					showing: "Showing {{start}}–{{end}} of {{total}}",
					previous: "Previous",
					next: "Next",
				},
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this schedule?",
					deleteMessage: "This action cannot be undone.",
				},
				table: {
					contact: "Contact",
					body: "Message",
					sendAt: "Scheduled Date",
					sentAt: "Sent Date",
					status: "Status",
					actions: "Actions",
				},
				buttons: {
					add: "New Schedule",
					edit: "Edit",
					delete: "Delete",
				},
				toasts: {
					deleted: "Schedule deleted successfully.",
				},
			},
			scheduleModal: {
				title: {
					add: "New Schedule",
					edit: "Edit Schedule",
				},
				subtitle: "Configure connection, contact, content and send date.",
				form: {
					connection: "Source connection",
					connectionHint: "Select the connection before searching for a contact.",
					body: "Message",
					contact: "Contact",
					searchContact: "Search contact",
					searchContactHint: "Type at least 3 characters to search.",
					contactSearchEmpty: "No contacts found.",
					sendAt: "Scheduled Date",
					sentAt: "Sent Date",
					media: "File",
					attachFile: "Attach file",
					removeFile: "Remove file",
					mediaHint: "Accepted media: jpg, jpeg, png, mp4 and pdf.",
					messageHint: "To insert variables into the message, type \"$\".",
					templateSection: "Approved template",
					templateSectionHint: "Select an approved template for the delivery.",
					templateParams: "Template parameters",
					paramText: "Free text",
					paramContactName: "Contact name",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				variablesTitle: "Message variables",
				statusLabel: "Status",
				contactRequired: "Select a contact from the search results before saving.",
				success: "Schedule saved successfully.",
			},
			tags: {
				title: "Tags",
				subtitle: "Administration",
				listTitle: "Tags list",
				countLabel: "records",
				searchPlaceholder: "Search tags...",
				empty: "No tags found.",
				emptyHint: "Try a different search term.",
				pagination: {
					label: "Pagination",
					showing: "Showing {{start}}–{{end}} of {{total}}",
					previous: "Previous",
					next: "Next",
				},
				selectAll: "Select all in list",
				selectRow: "Select {{name}}",
				selectedCount: "{{count}} selected",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this tag?",
					deleteMessage: "This action cannot be reversed.",
					deleteSelectedTitle: "Delete selected tags?",
					deleteSelectedMessage:
						"{{count}} tag(s) will be deleted. This action cannot be reversed.",
				},
				table: {
					id: "ID",
					name: "Name",
					color: "Color",
					tickets: "Tag Records",
					actions: "Actions",
					contacts: "Contacts",
					absentTag: "Absent tag",
					absentTagYes: "Yes",
				},
				buttons: {
					add: "Add tag",
					deleteSelected: "Delete selected",
					edit: "Edit",
					delete: "Delete",
				},
				toasts: {
					deleted: "Tag deleted successfully.",
					deletedSelected: "Selected tags deleted successfully.",
				},
			},
			settings: {
				success: "Settings saved successfully.",
				title: "Settings",
				apiKey: {
					regenerate: "Regenerate API Key",
					regenerateConfirm: "Generate a new API Key? The previous one will stop working. Copy the new key after confirming.",
					regenerateSuccess: "New API Key generated. Copy and store it in a safe place.",
					regenerateWarning: "When you regenerate, the previous key stops working. Use the new key in integrations.",
				},
				settings: {
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					CheckMsgIsGroup: {
						name: "Ignore group messages",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					call: {
						name: "Accept calls",
						note: "If disabled, the client will receive a message saying voice and video calls are not accepted.",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					sideMenu: {
						name: "Default side menu",
						note: "If enabled, the side menu will start closed.",
						options: {
							enabled: "Open",
							disabled: "Closed",
						},
					},
					closeTicketApi: {
						name: "Close ticket sent through the API",
						note: "Automatically closes the ticket when it is sent through the API.",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					darkMode: {
						name: "Enable dark mode",
						note: "Switch between light and dark modes.",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					businessTimezone: {
						name: "Time zone",
						note: "Defines the time zone used to display dates, times, and system filters.",
						options: {
							zone_serverDefault: "System default",
						},
					},
					timeCreateNewTicket: {
						name: "Create a new ticket after",
						note: "Select how long the system should wait before opening a new ticket if the customer contacts you again.",
						options: {
							10: "10 seconds",
							30: "30 seconds",
							60: "1 minute",
							300: "5 minutes",
							1800: "30 minutes",
							3600: "1 hour",
							7200: "2 hours",
							21600: "6 hours",
							43200: "12 hours",
							86400: "24 hours",
							604800: "7 days",
							1296000: "15 days",
							2592000: "30 days",
						},
					},
					sortBy: {
						nameOpen: "Sort open tickets by",
						namePending: "Sort pending tickets by",
						nameClosed: "Sort closed tickets by",
						note: "Select the order in which you want to view tickets.",
						options: {
							asc: "Oldest first",
							desc: "Newest first",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
						solverWithoutGoodbye: "Solve without goodbye",
					},
				},
			},
			messagesInput: {
				placeholderOpen:
					"Type a message or press ''/'' to use the registered quick responses",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				signMessage: "Sign",
				stickerPicker: {
					title: "Stickers",
					mine: "Mine",
					company: "Company",
					upload: "New",
					send: "Send sticker",
					loading: "Loading...",
					emptyMine: "No saved stickers. Save one from a chat.",
					emptyCompany: "No company stickers yet.",
					invalidEmpty: "Invalid or empty sticker.",
					invalidSize: "Sticker must be at most 512 KB (512000 bytes).",
					invalidMime:
						"Invalid format. Use image/webp (or application/octet-stream). PNG/JPEG are not supported.",
					remove: "Remove sticker",
					deleted: "Sticker removed",
					deletedCompany: "Sticker removed from company pack",
					deleteCompanyForbidden: "Only admins can remove company stickers",
					emojiTab: "Emojis",
				},
				micPermissionDeniedTitle: "Microphone blocked",
				micPermissionDenied:
					"Allow microphone access to record audio in this conversation.",
				micPermissionDeniedHint:
					"In your browser, click the lock icon next to the URL and set Microphone to Allow. Then reload the page.",
				micNotFoundTitle: "Microphone not found",
				micNotFound: "No microphone was detected on this device.",
				micInUseTitle: "Microphone in use",
				micInUse:
					"The microphone is being used by another app. Close it and try again.",
				micInsecureTitle: "Insecure connection",
				micInsecure: "Audio recording requires HTTPS or localhost.",
				micUnknownTitle: "Microphone error",
				micUnknown:
					"Could not start recording. Check browser permissions and try again.",
				dismissMicAlert: "Got it",
				composerTabsLabel: "Send mode",
				composerTabReply: "Reply",
				composerTabPrivate: "Private message",
				composerTabAiReport: "AI Report",
				privateMessagePlaceholder: "Type a note",
				privateMessageAlertTitle: "Private message",
				privateMessageTimelineBadge: "Team only",
				privateMessageAlert:
					"This note is visible only to your team. The customer does not receive or see this content.",
				privateMessageAlertHint:
					"Use this mode to record internal notes, reminders, or sensitive information about the conversation.",
				privateMessageHistoryTitle: "Private message history",
				privateMessageHistoryHint:
					"Only notes for this ticket. The customer cannot see this content.",
				privateMessageHistoryEmpty:
					"No private messages for this conversation yet.",
				privateMessageTicketRef: "Ticket #{{id}}",
				privateMessageUnknownAuthor: "Agent",
				dismissPrivateMessageAlert: "Got it",
				aiReport: {
					panelTitle: "AI Report",
					panelHint:
						"AI analyzes this ticket conversation and generates a summary with issues, emotional tone, and a conclusion. The customer cannot see this.",
					generate: "Generate report",
					generating: "Generating report...",
					generatedSuccess: "Report generated successfully",
					emptyTitle: "No reports yet",
					emptyHint:
						"Click Generate report to analyze this conversation.",
					ticketBadge: "Ticket #{{id}}",
					currentTicket: "Current ticket",
					summary: "Summary",
					problems: "Issues",
					noProblems: "No specific issues identified.",
					emotion: "Emotional tone",
					emotionUnknown: "undefined",
					conclusion: "Conclusion",
					generatedBy: "Generated by {{name}}",
				},
			},
			contactDrawer: {
				header: "Contact details",
				buttons: {
					edit: "Edit contact",
				},
				extraInfo: "Other information",
				bookings: {
					title: "Scheduled times",
					empty: "No scheduled times for this contact.",
					disconnected: "Google Calendar is not connected.",
					add: "Add time slot",
					loading: "Loading…",
					save: "Save",
					cancel: "Cancel",
					titleLabel: "Title",
					descriptionLabel: "Description",
					startLabel: "Start",
					endLabel: "End",
					saveSuccess: "Appointment scheduled successfully.",
					saveError: "Could not schedule.",
					loadError: "Could not load appointments.",
					sourceAi: "AI",
					sourceManual: "User",
					statusScheduled: "Scheduled",
					statusCompleted: "Completed",
					statusCancelled: "Cancelled",
					statusPostponed: "Postponed",
					changedBy: "Changed by",
					reason: "Reason",
					changeStatus: "Status",
					reasonOptional: "Reason (optional)",
					statusSaved: "Status updated.",
					statusSaveError: "Could not update status.",
					seeAll: "See all appointments",
					postponedBy: "Postponed by",
					newStart: "New start date/time",
					newEnd: "New end date/time",
					postponeRequired: "Enter the new date and time to postpone.",
					postponeInvalidRange: "End must be after start.",
					channelLabel: "Channel",
					channelUnknown: "Origin was not informed",
					channelReferral: "Referral",
					channelSite: "Website",
					channelOther: "Other",
					channelOtherLabel: "Which channel?",
					channelOtherPlaceholder: "E.g. TikTok, radio, flyer…",
					referredByLabel: "Referred by",
					referredByPlaceholder: "Name of who referred them",
					reminderScheduled: "Scheduled message",
				},
			},
			searchDrawer: {
				header: "Search message",
				searchLabel: "Search",
				yesterday: "yesterday",
				locale: "enUS",
			},
			ticketOptionsMenu: {
				delete: "Delete",
				transfer: "Transfer",
				confirmationModal: {
					title: "Delete ticket #",
					titleFrom: "from contact ",
					message: "Attention! All ticket's related messages will be lost.",
				},
				confirmationbukuModal: {
					title: "Delete selected tickets",
					message: "Warning! All messages related to the tickets will be lost.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				delete: "Delete",
				edit: "Edit",
				edited: "Edited",
				editEmpty: "Enter the new message text",
				editSuccess: "Message edited",
				reply: "Reply",
				downloadAudio: "Download audio",
				saveSticker: "Save sticker",
				saveStickerCompany: "Save company sticker",
				stickerSaved: "Sticker saved",
				stickerAlreadySaved: "Sticker already saved",
				editModal: {
					title: "Edit message",
					confirm: "Save",
				},
				confirmationModal: {
					title: "Delete message?",
					message: "This action cannot be reverted.",
				},
			},
			languages: {
				undefined: "Language",
				"pt-BR": "Portuguese",
				es: "Spanish",
				en: "English",
			},
			tagModal: {
				title: {
					add: "Create Tag",
					edit: "Edit Tag",
				},
				form: {
					name: "Name",
					color: "Color",
					pickColor: "Pick color",
					absentTag: "Absent tag",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Tag saved successfully.",
			},
			backendErrors: {
				TICKET_NOT_FOUND: "Ticket not found.",
				ERR_INVALID_NUMBER_LENGTH: "Number too long (max 15 digits including country code).",
				ERR_INVALID_BR_NUMBER: "Invalid Brazilian number: use 55 + area code + number.",
				ERR_TAG_NAME_ALREADY_EXISTS: "A tag with that name already exists.",
				ERR_NO_OTHER_WHATSAPP:
					"There must be at lest one default WhatsApp connection.",
				ERR_NO_DEF_WAPP_FOUND:
					"No default WhatsApp found. Check connections page.",
				ERR_WAPP_NOT_INITIALIZED:
					"This WhatsApp session is not initialized. Check connections page.",
				ERR_WAPP_CHECK_CONTACT:
					"Could not check WhatsApp contact. Check connections page.",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
				ERR_WAPP_BULK_INVALID_CONTACT: "All contacts are not valid Whatsapp numbers or there is a problem with the connection.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Could not download media from WhatsApp. Check connections page.",
				ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
				ERR_SENDING_WAPP_MSG:
					"Error sending WhatsApp message. Check connections page.",
				ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
				ERR_OTHER_OPEN_TICKET:
					"There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED: "Session expired. Please login.",
				ERR_USER_CREATION_DISABLED:
					"User creation was disabled by administrator.",
				ERR_NO_PERMISSION: "You don't have permission to access this resource.",
				ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
				ERR_COMPANY_NOT_FOUND_FOR_USER:
					"Could not identify the user's company for this operation.",
				ERR_NO_SETTING_FOUND: "No setting found with this ID.",
				ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
				ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
				ERR_NO_USER_FOUND: "No user found with this ID.",
				ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE: "Error while creating message on database.",
				ERR_CREATING_TICKET: "Error while creating ticket on database.",
				ERR_FETCH_WAPP_MSG: "Error fetching the message in WhtasApp, maybe it is too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS: "This color is already in use, pick another one.",
				ERR_WAPP_GREETING_REQUIRED: "Greeting message is required if there is more than one queue.",
				ERR_CNPJ_INVALID: "Invalid CNPJ.",
				ERR_CNPJ_ALREADY_REGISTERED: "This CNPJ is already registered.",
				ERR_INVALID_EMAIL: "Invalid email.",
				ERR_SIGNUP_RATE_LIMIT: "Too many attempts. Try again in 15 minutes.",
				ERR_EMAIL_SEND_FAILED: "Could not send email. Try again later.",
				ERR_INVALID_RESET_TOKEN: "Invalid or expired link. Request password recovery again.",
				ERR_INVALID_CODE: "Invalid code.",
				ERR_INVALID_OR_EXPIRED_CODE: "Invalid or expired code.",
				ERR_VERIFICATION_TOKEN_REQUIRED: "Verification token is required.",
				ERR_VERIFICATION_TOKEN_INVALID: "Verification token invalid or expired.",
				ERR_VERIFICATION_TOKEN_MISMATCH: "Data does not match verification.",
				ERR_VERIFICATION_TOKEN_ALREADY_USED: "This verification link has already been used.",
				ERR_PASSWORD_MIN_LENGTH: "Password must be at least 8 characters.",
				ERR_PASSWORD_UPPERCASE: "Password must contain at least one uppercase letter.",
				ERR_PASSWORD_SPECIAL: "Password must contain at least one special character.",
				ERR_USER_CREATION_COUNT:
					"User limit reached for this company. Each company can have 2 users in addition to the administrator.",
				ERR_CANNOT_REMOVE_COMPANY_OWNER:
					"The company administrator cannot be removed.",
				ERR_CONNECTION_CREATION_COUNT: "Connection limit reached, to change contact support.",
				BULK_HAS_NO_CONTACTS_TO_SEND: "There are no contacts to send bulk message."
			},
		},
	},
};

export { messages };
